import { create } from 'zustand'


const useStore = create(
    (set) => ({

        showCart: true,

        toggleCart: () => set(state => {

            return {...state, showCart: !state.showCart}
        }),
    
    }),
)


export default useStore;